// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6759":"3478018b","7055":"786324a3","7328":"1a5521c2","7504":"3478018b","8190":"002a90dd"}[chunkId] + ".chunk.css";
};